/* GarajMoto: homepage scooter selector v2 (uses window.GMV from gm-vehicle.js)
   Brand is optional; the model field searches across all brands ("vivacity 50").
   Selection goes to /collections/piese-scuter?m=<id>. */
(function () {
  'use strict';
  function init(root) {
    var G = window.GMV; if (!G || root.dataset.gmInit) return; root.dataset.gmInit = '1';
    var $ = function (s) { return root.querySelector(s); };
    var brandIn = $('#gm-brand'), modelIn = $('#gm-model'), brandList = $('[data-for="brand"]'), modelList = $('[data-for="model"]'), go = $('#gm-search');
    var ST = { brand: null, model: null };

    root.querySelectorAll('.gm-tab').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.gm-tab').forEach(function (x) { x.classList.toggle('gm-tab--active', x === t); });
        root.querySelectorAll('.gm-mode').forEach(function (m) { m.hidden = m.dataset.mode !== t.dataset.mode; });
      });
    });

    function combo(input, list, getItems, onPick) {
      var items = [], hl = -1;
      function render() {
        getItems(input.value).then(function (res) {
          items = res;
          list.innerHTML = items.length ? items.map(function (it, i) { return '<div class="gm-combo__item" data-i="' + i + '">' + G.esc(it.label) + (it.meta ? '<small>' + G.esc(it.meta) + '</small>' : '') + '</div>'; }).join('') : '<div class="gm-combo__empty">Niciun rezultat</div>';
          list.classList.add('is-open'); hl = -1;
          list.querySelectorAll('[data-i]').forEach(function (el) { el.addEventListener('mousedown', function (e) { e.preventDefault(); choose(items[+el.dataset.i]); }); });
        });
      }
      function choose(it) { input.value = it.label; list.classList.remove('is-open'); onPick(it); }
      input.addEventListener('focus', render); input.addEventListener('input', function () { onPick(null, true); render(); });
      input.addEventListener('blur', function () { setTimeout(function () { list.classList.remove('is-open'); }, 150); });
      input.addEventListener('keydown', function (e) {
        var els = list.querySelectorAll('[data-i]');
        if (e.key === 'ArrowDown') { e.preventDefault(); hl = Math.min(els.length - 1, hl + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); hl = Math.max(0, hl - 1); }
        else if (e.key === 'Enter') { e.preventDefault(); var it = items[hl > -1 ? hl : 0]; if (it) choose(it); return; }
        else if (e.key === 'Escape') { list.classList.remove('is-open'); return; }
        els.forEach(function (el, i) { el.classList.toggle('is-highlighted', i === hl); });
        if (els[hl]) els[hl].scrollIntoView({ block: 'nearest' });
      });
    }

    combo(brandIn, brandList, function (q) {
      return G.models().then(function (all) {
        var cnt = {}; all.forEach(function (m) { cnt[m.brand] = (cnt[m.brand] || 0) + 1; });
        var nq = G.norm(q);
        return Object.keys(cnt).filter(function (b) { return !nq || G.norm(b).indexOf(nq) > -1; })
          .sort(function (a, b) { return cnt[b] - cnt[a]; }).slice(0, 80)
          .map(function (b) { return { label: b, meta: cnt[b] + ' modele', value: b }; });
      });
    }, function (it, typing) {
      if (typing) { ST.brand = null; return; }
      ST.brand = it ? it.value : null; ST.model = null; modelIn.value = ''; update(); modelIn.focus();
    });

    combo(modelIn, modelList, function (q) {
      return G.models().then(function (all) {
        if (!ST.brand && G.norm(q).length < 2) return [];
        return G.searchModels(all, q, ST.brand, 60).map(function (m) {
          return { label: (ST.brand ? '' : m.brand + ' ') + m.d, meta: [G.modelMeta(m), m.n + ' piese compatibile'].filter(Boolean).join(' · '), m: m };
        });
      });
    }, function (it, typing) { ST.model = typing ? null : (it ? it.m : null); update(); if (ST.model) go.focus(); });

    function update() { go.disabled = !ST.model; }
    go.addEventListener('click', function () { if (!ST.model) return; G.save(ST.model.brand, ST.model.id, ST.model.d); location.href = G.url(ST.model.id); });

    // VIN / frame code lookup
    var vin = $('#gm-vin'), vinRes = $('#gm-vin-result');
    if (vin) vin.addEventListener('input', function () {
      var v = vin.value.toUpperCase().replace(/[^A-Z0-9]/g, ''); vin.value = v;
      if (v.length < 3) { vinRes.innerHTML = ''; return; }
      Promise.all([G.fitment(), G.models()]).then(function (r) {
        var D = r[0], all = r[1], found = null, code = null;
        for (var L = Math.min(v.length, 12); L >= 3; L--) { var p = v.substring(0, L); if (D.f[p]) { found = D.f[p]; code = p; break; } }
        var ms = (found || []).map(function (id) { for (var i = 0; i < all.length; i++) if (all[i].id === id) return all[i]; return null; }).filter(Boolean);
        if (!ms.length) { vinRes.innerHTML = '<div class="gm-vin-result gm-vin-result--none">Nu am putut identifica scuterul după seria de șasiu. Încearcă căutarea după model.</div>'; return; }
        vinRes.innerHTML = '<div class="gm-vin-result ' + (ms.length === 1 ? 'gm-vin-result--match' : 'gm-vin-result--multi') + '"><strong>' + (ms.length === 1 ? '✓ Model identificat' : 'Codul se potrivește la mai multe variante, alege-o pe a ta') + ' (cod: ' + G.esc(code) + ')</strong>' +
          ms.slice(0, 8).map(function (m) { return '<a class="gm-vin-pick" href="' + G.url(m.id) + '"><strong>' + G.esc(m.brand) + '</strong> ' + G.esc(m.d) + '<small style="display:block;color:#666;">' + [G.modelMeta(m), m.n + ' piese compatibile'].filter(Boolean).join(' · ') + '</small></a>'; }).join('') + '</div>';
      });
    });

    // Saved scooter pill
    var sv = G.saved(), box = $('#gm-saved');
    if (sv && box) {
      box.hidden = false;
      box.innerHTML = '<div class="gm-saved-pill"><span style="font-size:20px;">🛵</span><div><small>Scuterul tău</small><strong>' + G.esc(sv.brand + ' ' + sv.display) + '</strong></div>' +
        '<a href="#" data-gm-clear class="gm-saved-pill__link">Schimbă</a><a href="' + G.url(sv.modelId) + '" class="gm-saved-pill__link gm-saved-pill__link--main">Vezi piesele »</a></div>';
      box.querySelector('[data-gm-clear]').addEventListener('click', function (e) { e.preventDefault(); G.clear(); box.hidden = true; brandIn.focus(); });
    }
  }
  function boot() { document.querySelectorAll('.gm-selector').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
